<template>
  <div
    class="margin-top-10 margin-bottom-10 is-unselectable"
    v-if="firstLoadDone && visible"
  >
    <transition
      name="custom-classes-transition"
      enter-active-class="pulse-fast-once"
      appear
    >
      <div class="tag is-primary is-light clickable" @click="save()">
        
        <span class="tips-text">
          <slot></slot>
        </span>
        <button class="delete is-small"></button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {
    RightClickIcon: () => import("@/components/singles/RightClickIcon.vue"),
  },
  props: {
    rightClickIconVisible: Boolean,
    path: String,
    xKey: String,
    property: String,
  },
  computed: {
    visible() {
      return !(
        this.$store.state.settings.user[this.path] &&
        this.$store.state.settings.user[this.path][this.xKey] &&
        this.$store.state.settings.user[this.path][this.xKey][this.property]
      );
    },
  },

  data() {
    return {
      firstLoadDone: false,
    };
  },

  async created() {
    await this.$store.dispatch("settings/getUserSetting", {
      path: this.path,
      xKey: this.xKey,
    });

    this.firstLoadDone = true;
  },

  methods: {
    async save() {
      const value = { ...this.$store.state.settings.user[this.path] };
      if (value[this.xKey] === undefined) value[this.xKey] = {};

      value[this.xKey][this.property] = true;

      await this.$store.dispatch("settings/setUser", {
        path: this.path,
        key: this.xKey,
        value: value[this.xKey],
      });
    },
  },
};
</script>
